"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mountIsland_1 = require("../mountIsland");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var Lang_js_1 = require("../Lang.js");
var NAVY = '#1c1c3c';
var TwiSuccessPage = function () {
    var container = document.getElementById('twi-success-page');
    var dataset = (container === null || container === void 0 ? void 0 : container.dataset) || {};
    var planName = dataset.planName || 'TWI Premium';
    return (react_1.default.createElement(Box_1.default, { sx: {
            p: 2, maxWidth: '680px', mx: 'auto', mt: { xs: 2, sm: 4 },
            backgroundColor: '#f5f6f8',
        } },
        react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
                p: { xs: '28px 20px', sm: '48px' },
                borderRadius: 2,
                backgroundColor: '#fff',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                textAlign: 'center',
            } },
            react_1.default.createElement(Box_1.default, { sx: {
                    width: '72px', height: '72px', borderRadius: '50%',
                    backgroundColor: 'rgba(25,148,32,0.10)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    mx: 'auto', mb: 3,
                } },
                react_1.default.createElement(Typography_1.default, { sx: { fontSize: '36px', color: '#1a6e1e', lineHeight: 1 } }, "\u2713")),
            react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h1", sx: { m: 0, fontSize: '26px', fontWeight: 700, color: NAVY, lineHeight: 1.2 } }, (0, Lang_js_1.__)('You\'re all set!')),
            react_1.default.createElement(Typography_1.default, { sx: { mt: 1.5, fontSize: '16px', color: '#333', lineHeight: 1.6 } },
                (0, Lang_js_1.__)('Your'),
                " ",
                react_1.default.createElement("strong", null, planName),
                " ",
                (0, Lang_js_1.__)('subscription is now active.')),
            react_1.default.createElement(Typography_1.default, { sx: { mt: 1, fontSize: '14px', color: '#666', lineHeight: 1.6 } }, (0, Lang_js_1.__)('You now have full access to the TWI video library. We have emailed you a confirmation, and your receipt is on your subscription page.')),
            react_1.default.createElement(Box_1.default, { sx: {
                    mt: 3, p: '18px 20px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: 1.5,
                    textAlign: 'left',
                } },
                react_1.default.createElement(Typography_1.default, { sx: { fontSize: '13px', fontWeight: 700, color: '#555', mb: 1.5, textTransform: 'uppercase', letterSpacing: '0.5px' } }, (0, Lang_js_1.__)('What\'s next')),
                [
                    (0, Lang_js_1.__)('Browse the TWI video library'),
                    (0, Lang_js_1.__)('Create playlists and save favourites'),
                    (0, Lang_js_1.__)('Manage billing anytime via your subscription page'),
                ].map(function (step, i) { return (react_1.default.createElement(Box_1.default, { key: i, sx: { display: 'flex', alignItems: 'center', gap: 1.5, mb: i < 2 ? 1 : 0 } },
                    react_1.default.createElement(Box_1.default, { sx: {
                            width: '22px', height: '22px', borderRadius: '50%',
                            backgroundColor: NAVY, color: '#fff',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            flexShrink: 0, fontSize: '12px', fontWeight: 700,
                        } }, i + 1),
                    react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', color: '#333' } }, step))); })),
            react_1.default.createElement(Box_1.default, { sx: { mt: 3, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1.5, justifyContent: 'center' } },
                react_1.default.createElement(Box_1.default, { component: "a", href: "/app/twi/", sx: {
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        height: '46px', px: 4, borderRadius: '6px',
                        backgroundColor: NAVY, color: '#fff',
                        fontSize: '14px', fontWeight: 700, textDecoration: 'none',
                        '&:hover': { backgroundColor: '#2a2a4c', textDecoration: 'none', color: '#fff' },
                    } }, (0, Lang_js_1.__)('Go to TWI')),
                react_1.default.createElement(Box_1.default, { component: "a", href: "/app/subscriptions/manage", sx: {
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        height: '46px', px: 4, borderRadius: '6px',
                        border: "2px solid ".concat(NAVY), color: NAVY,
                        fontSize: '14px', fontWeight: 700, textDecoration: 'none',
                        '&:hover': { backgroundColor: 'rgba(28,28,60,0.04)', textDecoration: 'none', color: NAVY },
                    } }, (0, Lang_js_1.__)('Back to Subscriptions'))))));
};
var twiSuccessEl = document.getElementById('twi-success-page');
if (twiSuccessEl) {
    (0, mountIsland_1.mountIsland)(twiSuccessEl, react_1.default.createElement(TwiSuccessPage, null));
}
exports.default = TwiSuccessPage;
